// @ts-nocheck — react-select inner components use loose prop shapes.
import React, { useCallback } from "react";
import { components } from "react-select";

function assignRef(ref, instance) {
  if (ref == null) return;
  if (typeof ref === "function") {
    ref(instance);
  } else {
    ref.current = instance;
  }
}

const CustomSelect = React.forwardRef(function CustomSelect(props, forwardedRef) {
  const {
    innerRef,
    ref: refProp,
    autoCorrect: _unusedAutoCorrect,
    autoCapitalize: _unusedAutoCapitalize,
    ...rest
  } = props;

  const mergedInnerRef = useCallback(
    instance => {
      assignRef(innerRef, instance);
      assignRef(forwardedRef, instance);
      assignRef(refProp, instance);
    },
    [innerRef, forwardedRef, refProp]
  );

  return <components.Input {...rest} innerRef={mergedInnerRef} />;
});

CustomSelect.displayName = "CustomSelect";

export default CustomSelect;
